import { combineReducers } from 'redux';
import {
    IS_FORM_OPEN,
    IS_FORM_CLOSE,
    IS_FORM_ERROR,
    INITIAL_STATE_IS_FORM,
    INITIAL_STATE_IS_ACTION,
    IS_ACTION_PROCESS,
    IS_ACTION_SUCCESS,
    IS_ACTION_FAILURE,
    GET_DATA_SUCCESS,
    INITIAL_STATE_GET_DATA,
    GET_DATA_LOADING,
    GET_DATA_ERROR,
    INITIAL_STATE_TIPE_CARGO,
    DATA_TIPE_CARGO_PROCESS,
    DATA_TIPE_CARGO_SUCCESS,
    DATA_TIPE_CARGO_FAILURE
} from '../actions/masterKodeTrayekAction';

const getData = (state = INITIAL_STATE_GET_DATA, actions) => {
    switch (actions.type) {
        case GET_DATA_LOADING:
            return {
                ...INITIAL_STATE_GET_DATA,
                type: 'LOADING',
                loading: true
            }
        case GET_DATA_SUCCESS:
            return {
                ...INITIAL_STATE_GET_DATA,
                type: 'SUCCESS',
                data: actions.data
            }
        case GET_DATA_ERROR:
            return {
                ...INITIAL_STATE_GET_DATA,
                type: 'ERROR',
                error: true
            }
        default:
            return state
    }
}

const isForm = (state = INITIAL_STATE_IS_FORM, actions) => {
    switch (actions.type) {
        case IS_FORM_OPEN:
            return {
                ...state,
                active: true,
                save: actions.save,
                data: actions.data,
                error: false
            }
        case IS_FORM_CLOSE:
            return INITIAL_STATE_IS_FORM
        case IS_FORM_ERROR:
            return {
                ...state,
                active: true,
                save: actions.save,
                data: actions.data,
                error: actions.error
            }
        default:
            return state
    }
}

const isActions = (state = INITIAL_STATE_IS_ACTION, actions) => {
    switch (actions.type) {
        case IS_ACTION_PROCESS:
            return {
                ...state,
                type: 'proses',
                loading: true,
                method: actions.method,
                data: actions.data,
                error: false
            };
        case IS_ACTION_SUCCESS:
            return {
                ...state,
                type: 'success',
                loading: false,
                method: actions.method,
                data: [],
                error: false
            }
        case IS_ACTION_FAILURE:
            return {
                ...state,
                type: 'error',
                loading: false,
                method: actions.method,
                data: actions.data,
                error: true
            }
        default:
            return INITIAL_STATE_IS_ACTION;
    }
}

const tipeCargo = (state = INITIAL_STATE_TIPE_CARGO, actions) => {
    switch (actions.type) {
        case DATA_TIPE_CARGO_PROCESS:
            return {
                ...INITIAL_STATE_TIPE_CARGO,
                type: 'LOADING',
                loading: true
            }
        case DATA_TIPE_CARGO_SUCCESS:
            return {
                ...INITIAL_STATE_TIPE_CARGO,
                type: 'SUCCESS',
                data: actions.data
            }
        case DATA_TIPE_CARGO_FAILURE:
            return {
                ...INITIAL_STATE_TIPE_CARGO,
                type: 'ERROR',
                error: true
            }
        default: return state;
    }
}

const GET_DATA_FILTER_TRAYEK = 'GET_DATA_FILTER_TRAYEK';
const initialFilterTrayek = {
    loading: false,
    success: false,
    error: false,
    data: []
}

const getDataFilterTrayek = (state = initialFilterTrayek, actions) => {
    switch (actions.type) {
        case GET_DATA_FILTER_TRAYEK + '_LOADING':
            return {
                ...initialFilterTrayek,
                loading: true
            }
        case GET_DATA_FILTER_TRAYEK + '_ERROR':
            return {
                ...initialFilterTrayek,
                error: true
            }
        case GET_DATA_FILTER_TRAYEK + '_SUCCESS':
            return {
                ...initialFilterTrayek,
                success: true,
                data: actions.data
            }
        case GET_DATA_FILTER_TRAYEK + '_CLEAR':
            return initialFilterTrayek
        default: return state
    }
}

const spokeViewError = (state = false, action) => {
    switch (action.type) {
        case 'SPOKE_VIEW_ERROR':
            return action.spokeViewError
        default:
            return state
    }
}

const spokeViewLoading = (state = false, action) => {
    switch (action.type) {
        case 'SPOKE_VIEW_LOADING':
            return action.spokeViewLoading
        default:
            return state
    }
}
const spokeViewSuccess = (state = false, action) => {
    switch (action.type) {
        case 'SPOKE_VIEW_SUCCESS':
            return action.spokeViewSuccess
        default:
            return state
    }
}

const spoke = (state = [], action) => {
    switch (action.type) {
        case 'SPOKE_VIEW_SUCCESS':
            return action.spoke
        default:
            return state
    }
}
const kodeTrayekReducer = combineReducers({
    getData,
    isForm,
    isActions,
    tipeCargo,
    spokeViewLoading,
    spokeViewError,
    spokeViewSuccess,
    spoke,
    getDataFilterTrayek
})

export default kodeTrayekReducer